import type { ReactNode } from 'react'

/**
 * A ação principal do celular, fixa acima da barra inferior e ao alcance do polegar
 * (docs/styleguide/07-responsividade.md, "Toque e teclado"). Só é montada abaixo de `desk`; o
 * espaçador impede que a barra cubra o fim do conteúdo.
 */
export function MobileActionBar({ children }: { children: ReactNode }) {
  return (
    <>
      <div aria-hidden className="h-20" />
      <div className="border-hairline bg-surface px-safe fixed inset-x-0 bottom-[calc(var(--spacing-touch)+env(safe-area-inset-bottom,0px))] z-10 border-t">
        <div className="flex gap-3 px-4 py-3">{children}</div>
      </div>
    </>
  )
}
